import type { ClientUiImageModel, ClientUiPublic } from '../api/platformConfig'
import { isReferenceImageUploadSupported } from './bananaModel'

/** 漫画生图仅允许支持参考图的模型 */
export function comicReferenceCapableModels(
  clientUi: ClientUiPublic,
): ClientUiImageModel[] {
  return clientUi.imageModels.filter((m) =>
    isReferenceImageUploadSupported(m.platform, m.id, clientUi.imageModels),
  )
}

export function comicHasReferenceCapableModels(clientUi: ClientUiPublic): boolean {
  return comicReferenceCapableModels(clientUi).length > 0
}
